import { API_BASE } from './config';

const getAccessToken = () => localStorage.getItem('authToken');
const getRefreshToken = () => localStorage.getItem('refreshToken');
const saveAccessToken = (t: string) => localStorage.setItem('authToken', t);

let isRefreshing = false;
let refreshQueue: ((token: string) => void)[] = [];

let globalOpenLoginModal: (() => void) | null = null;

export const setGlobalLoginModal = (fn: () => void) => {
  globalOpenLoginModal = fn;
};

const refreshAccessToken = async (): Promise<string | null> => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) return null;

  if (isRefreshing) {
    return new Promise((resolve) => refreshQueue.push(resolve));
  }

  isRefreshing = true;
  try {
    const res = await fetch(`${API_BASE}/otp/refresh?refresh_token=${refreshToken}`, {
      method: 'POST',
    });
    if (!res.ok) return null;
    const { token } = await res.json();
    saveAccessToken(token);
    refreshQueue.forEach((cb) => cb(token));
    refreshQueue = [];
    return token;
  } catch {
    return null;
  } finally {
    isRefreshing = false;
  }
};

function buildHeaders(init?: RequestInit, overrideToken?: string): RequestInit {
  const headers = new Headers(init?.headers || {});
  const token = overrideToken || getAccessToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  if (!headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  return { ...init, headers };
}

export const apiFetch = async (input: string, init?: RequestInit): Promise<Response> => {
  const response = await fetch(input, buildHeaders(init));

  if (response.status === 401) {
    const newToken = await refreshAccessToken();
    if (!newToken) {
      globalOpenLoginModal?.();
      return response;
    }
    return fetch(input, buildHeaders(init, newToken));
  }

  return response;
};
